import Vue from 'vue';
import router from './router';
import App from './MainApp.vue';
import Vuelidate from 'vuelidate';
import store from './store';
import LayoutHandler from '@/components/layouts/LayoutHandler.vue';
import VueCookies from 'vue-cookies';

Vue.use(VueCookies);

Vue.config.productionTip = false;

Vue.use(Vuelidate);
Vue.component('LayoutHandler', LayoutHandler);

// Function to remove CSRF token from cookies
function delete_cookie(name) {
  document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

if (!localStorage.getItem('cookiesAccepted')) {
	delete_cookie('canon_ph_app_session');
	delete_cookie('XSRF-TOKEN');
	delete_cookie('laravel_session');
}

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
